/*eslint-disable*/
export default {
  init() {

    $(document).ready(function() {
      $("#lightgallery2").lightGallery();
    });

    $('.myList').showMoreItems({
      startNum: 16,
      afterNum: 16,
    });




  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/singleGalleryRace.js